<template>
  <div class="modal-message">
    <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">
          <div v-if="institute.names && institute.names.length > 0">
            <div v-for="name in institute.names">{{name.name}}</div>
          </div>
          <div v-else>{{institute.name}}</div>
        </h4>
        <p class="category"></p>
      </div>
      <div class="card-content">
        <p>Unfortunately Qualification Check cannot process verification requests for this institute.</p>
        <p v-if="notices1 && notices1.length > 0" v-for="notice in notices1">{{notice.message}}</p>
        <p v-if="notices2 && notices2.length > 0" v-for="notice in notices2">{{notice.message}}</p>
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button @click="$modal.close()" class="btn btn-fill pull-right">Ok</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'modal-info-only-institute',
    data () {
      return {
        notices1: [],
        notices2: [],
        loading: false
      }
    },
    props: {
      institute: Object
    },
    mounted: function () {
      this.loading = true
      this.$api.getNotices(this.institute.id, 'READONLY_INFO')
        .then(response => {
          this.notices1 = response.data.content
          this.$api.getNotices(null, 'READONLY_INFO', this.institute.regionId)
            .then(response2 => {
              this.notices2 = response2.data.content
              this.loading = false
            })
        }).catch(error => {
          console.log(error)
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    }
  }
</script>

<style>
  .modal-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>